module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogShow),
      expression: "dialogShow"
    }],
    attrs: {
      "title": "配置选项",
      "size": "small"
    },
    domProps: {
      "value": (_vm.dialogShow)
    },
    on: {
      "input": function($event) {
        _vm.dialogShow = $event
      }
    }
  }, [_c('div', _vm._l((_vm.configData), function(item) {
    return _c('span', [_c('el-button', {
      staticClass: "m-l-10 m-t-10",
      on: {
        "click": function($event) {
          _vm.goConfig(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bae5c8e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/page/configuration.vue
// module id = 1977
// module chunks = 2